import { getAccounts } from '../../utils/accountStructure/accountStructureUtils';

const ALL = '-2';
const NONE = '-1';
const toStr = (v) => (v == null ? '' : String(v));
const toStrArr = (a) => (Array.isArray(a) ? a.map(toStr) : []);

export function parseAllocationsData(allocations, businessCases, entities, accountStructure) {
  const flatEntities = [];
  (function flatten(list) {
    (list || []).forEach((n) => {
      flatEntities.push(n);
      if (Array.isArray(n.children) && n.children.length) flatten(n.children);
    });
  })(entities || []);

  const flatScenarios = flatEntities.flatMap((e) =>
    Array.isArray(e.scenario) ? e.scenario : []
  );

  const flatAccounts = getAccounts?.([], accountStructure) || [];

  const bcNameById = new Map((businessCases ?? []).map((b) => [toStr(b.business_case_id), b.name]));
  const entityNameById = new Map(
    (flatEntities ?? []).map((e) => [toStr(e.entity_id ?? e.id ?? e.entityId), e.name])
  );
  const scenarioNameById = new Map(
    (flatScenarios ?? []).map((s) => [toStr(s.scenario_id ?? s.id ?? s.scenarioId), s.name])
  );
  const accountNameById = new Map(
    (flatAccounts ?? []).map((a) => [toStr(a.associated_account_id ?? a.account_id ?? a.accountId), a.name])
  );
  const accountNumberById = new Map(
    (flatAccounts ?? []).map((a) => [toStr(a.associated_account_id ?? a.account_id ?? a.accountId), a.account_number,])
  );

  const parseSingle = (idStr, map) => {
    if (idStr === ALL) return 'All';
    if (idStr === NONE || idStr === '' || idStr === '0') return 'None';
    return map.get(idStr) ?? idStr;
  };
  
  const parseAccountNumber = (idStr) => {
    if (idStr === ALL || idStr === NONE || idStr === '' || idStr === '0') return '';
    return toStr(accountNumberById.get(idStr));
  };

  const getBusinessCaseScenarioIds = (businessCaseId) => {
    const bc = (businessCases ?? []).find((b) => toStr(b.business_case_id) === toStr(businessCaseId));
    return (bc?.business_scenario ?? []).map((bs) => toStr(bs.scenario_id));
  };

const getExpandedScenarioNames = (ids, businessCaseId, entityId) => {
  const idsStrArr = toStrArr(ids);

  if (!idsStrArr.length || idsStrArr.includes(NONE)) return 'None';

  const entityIdStr = toStr(entityId);
  const hasEntity = entityIdStr !== '' && entityIdStr !== '0' && entityIdStr !== NONE;

  if (idsStrArr.includes(ALL)) {
    let scoped = flatScenarios;

    if (businessCaseId && businessCaseId !== '0' && businessCaseId !== NONE) {
      const bcScenarioIds = new Set(getBusinessCaseScenarioIds(businessCaseId));
      scoped = scoped.filter((s) =>
        bcScenarioIds.has(toStr(s.scenario_id ?? s.id ?? s.scenarioId))
      );
    }

    if (hasEntity) {
      scoped = scoped.filter(
        (s) => toStr(s.entity_id ?? s.entityId) === entityIdStr
      );
    }

    const names = scoped.map(
      (s) =>
        scenarioNameById.get(toStr(s.scenario_id ?? s.id ?? s.scenarioId)) ??
        toStr(s.scenario_id ?? s.id ?? s.scenarioId)
    );

    return names.length ? names.join(', ') : 'All';
  }

  return idsStrArr.map((id) => scenarioNameById.get(id) ?? id).join(', ');
};

  return (allocations ?? [])
    .filter(Boolean)
    .map((a) => {
      const businessCaseId = toStr(a?.businessCaseId ?? a?.business_case_id);
      const entityId = toStr(a?.entityId ?? a?.entity_id);
      const accountId = toStr(a?.accountId ?? a?.account_id);
      const targetEntityId = toStr(a?.targetEntityId ?? a?.target_entity_id);
      const targetAccountId = toStr(a?.targetAccountId ?? a?.target_account_id);
      const scenarioId = toStrArr(a?.scenarioId ?? a?.scenario_id);
      const targetScenarioId = toStrArr(a?.targetScenarioId ?? a?.target_scenario_id);

      return {
        ...a,

        businessCaseId,
        entityId,
        accountId,
        targetEntityId,
        targetAccountId,
        scenarioId,
        targetScenarioId,

        businessCaseName: parseSingle(businessCaseId, bcNameById),
        entityName: parseSingle(entityId, entityNameById),
        accountName: parseSingle(accountId, accountNameById),
        targetEntityName: parseSingle(targetEntityId, entityNameById),
        targetAccountName: parseSingle(targetAccountId, accountNameById),

        scenarioNames: getExpandedScenarioNames(scenarioId, businessCaseId, entityId),
        targetScenarioNames: getExpandedScenarioNames(targetScenarioId, businessCaseId, targetEntityId),

        accountNumber: parseAccountNumber(accountId),
        targetAccountNumber: parseAccountNumber(targetAccountId),
      };
    });
}